import { useEffect, useState, useReducer } from "react";
import { Preferences } from '@capacitor/preferences';


export function usePersistantLocal(key, init) {
    const [val, setVal] = useState(init);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const savedValue = await Preferences.get({key: key});
                if(savedValue.value !== null && val === init) setVal(JSON.parse(savedValue.value));
            } catch (error) {
                console.error('Error getting data from Preferences:', error);
                return init;
            }
        };
        fetchData();
      }, []);
    
      useEffect(() => {
        const saveData = async () => {
          try {
            await Preferences.set({key: key, value: JSON.stringify(val)});
          } catch (error) {
            console.error('Error setting data in Preferences:', error);
          }
        };
        if(val !== init) saveData();
      }, [val]);

      return [val, setVal];
}

export function usePersistantLocalr(key, reducer, init) {
    const [val, dispatch] = useReducer(reducer, init);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const savedValue = await Preferences.get({key: key});
                if(savedValue.value !== null && val === init) dispatch({type: "replace", value: JSON.parse(savedValue.value)});
            } catch (error) {
                console.error('Error getting data from Preferences:', error);
                return init;
            }
        };
        fetchData();
      }, []);
    
      useEffect(() => {
        const saveData = async () => {
          try {
            await Preferences.set({key: key, value: JSON.stringify(val)});
          } catch (error) {
            console.error('Error setting data in Preferences:', error);
          }
        };
        if(val !== init) saveData();
      }, [val]);

      return [val, dispatch];
}

export function useLocal(key, init) {
    const savedVal = localStorage.getItem(key)
    const realVal =  savedVal ? JSON.parse(savedVal) : init;
    
    const [val, setVal] = useState(realVal);
   
    useEffect(() => {
      localStorage.setItem(key, JSON.stringify(val));
    }, [val]);
   
    return [val, setVal];
}

export function useLocalr(key, reducer, init) {
 const savedVal = localStorage.getItem(key)

 const realVal = savedVal ? JSON.parse(savedVal) : init;

 const [val, dispatch] = useReducer(reducer, realVal);

 useEffect(() => {
  localStorage.setItem(key, JSON.stringify(val));
 }, [val]);

 return [val, dispatch];
}
